function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from "react";
import { Eye, EyeOff, Truck, AlertTriangle, ArrowRight, ShieldCheck, Package, Users, MapPin } from "lucide-react";
import { Image } from "antd";
import UserLogin from "./forms/UserLogin";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HomeContent = function HomeContent() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    email = _useState4[0],
    setEmail = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = useState(""),
    _useState0 = _slicedToArray(_useState9, 2),
    error = _useState0[0],
    setError = _useState0[1];
  var stats = [{
    label: "Livraisons aujourd'hui",
    value: "0",
    mod: "blue",
    icon: /*#__PURE__*/_jsx(Truck, {
      size: 18,
      strokeWidth: 2
    }),
    color: "#8F734C",
    bg: "#F1EBE1"
  }, {
    label: "Techniciens actifs",
    value: "0",
    mod: "cyan",
    icon: /*#__PURE__*/_jsx(Users, {
      size: 18,
      strokeWidth: 2
    }),
    color: "#0891b2",
    bg: "#F0F1E3"
  }, {
    label: "Bouteilles en stock",
    value: "0",
    mod: "violet",
    icon: /*#__PURE__*/_jsx(Package, {
      size: 18,
      strokeWidth: 2
    }),
    color: "#277A92",
    bg: "#DBECF1"
  }];
  return /*#__PURE__*/_jsxs("div", {
    style: {
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      fontFamily: "'Barlow', sans-serif",
      background: "#f0f4f8"
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "52%",
        position: "relative",
        overflow: "hidden",
        padding: "3rem",
        background: "#ffffff",
        borderRight: "1px solid rgba(37,99,235,0.14)"
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          backgroundImage: "radial-gradient(circle, rgba(37,99,235,0.12) 1.5px, transparent 1.5px)",
          backgroundSize: "28px 28px"
        }
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: "linear-gradient(90deg, #F1742E 0%, #F1935F 60%, #2E60B2 100%)"
        }
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          gap: "0.75rem"
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: "10.5rem",
            height: "4.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.5rem",
            background: "linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 100%)",
            boxShadow: "0 1px 4px rgba(37,99,235,0.3)",
            flexShrink: 0
          },
          children: /*#__PURE__*/_jsx(Image, {
            src: "drawables/alo.png",
            width: "100%"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("span", {
            style: {
              display: "block",
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 600,
              fontSize: "1rem",
              letterSpacing: "0.08em",
              color: "#1a2535"
            },
            children: "Admin"
          }), /*#__PURE__*/_jsx("span", {
            style: {
              display: "block",
              fontFamily: "'DM Mono', monospace",
              fontSize: "0.7rem",
              color: "#6b7f9e"
            },
            children: "v1.0"
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          position: "relative",
          zIndex: 1
        },
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: "inline-flex",
            alignItems: "center",
            gap: "0.4rem",
            fontFamily: "'DM Mono', monospace",
            fontSize: "0.7rem",
            textTransform: "uppercase",
            letterSpacing: "0.16em",
            color: "#2563eb",
            border: "1px solid rgba(37,99,235,0.25)",
            background: "rgba(37,99,235,0.06)",
            padding: "0.3rem 0.75rem",
            borderRadius: "999px",
            marginBottom: "1.5rem"
          },
          children: [/*#__PURE__*/_jsx(MapPin, {
            size: 11,
            strokeWidth: 2.5
          }), "Zone Administrateur"]
        }), /*#__PURE__*/_jsxs("h1", {
          style: {
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: "clamp(2.6rem, 4vw, 4.2rem)",
            fontWeight: 700,
            lineHeight: 1,
            letterSpacing: "-0.01em",
            color: "#1a2535",
            margin: "0 0 1.25rem"
          },
          children: ["GESTION DES", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
            style: {
              color: "#F1935F"
            },
            children: "LIVRAISONS"
          }), /*#__PURE__*/_jsx("br", {}), "GAZ"]
        }), /*#__PURE__*/_jsx("p", {
          style: {
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "#6b7f9e",
            maxWidth: "22rem",
            margin: 0
          },
          children: "Plateforme centralis\xE9e pour superviser les tourn\xE9es, g\xE9rer les stocks de bouteilles et suivre les techniciens en temps r\xE9el."
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: "relative",
          zIndex: 1,
          display: "grid",
          gridTemplateColumns: "repeat(3,1fr)",
          gap: "1rem"
        },
        children: stats.map(function (s) {
          return /*#__PURE__*/_jsxs("div", {
            style: {
              borderRadius: "0.75rem",
              padding: "1rem",
              background: s.bg,
              border: "1px solid ".concat(s.color, "20")
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                width: "2rem",
                height: "2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "0.5rem",
                background: s.color,
                color: "#fff",
                marginBottom: "0.75rem"
              },
              children: s.icon
            }), /*#__PURE__*/_jsx("div", {
              style: {
                fontFamily: "'Barlow Condensed', sans-serif",
                fontSize: "1.6rem",
                fontWeight: 700,
                color: s.color,
                marginBottom: "0.2rem"
              },
              children: s.value
            }), /*#__PURE__*/_jsx("div", {
              style: {
                fontFamily: "'DM Mono', monospace",
                fontSize: "0.68rem",
                color: "#6b7f9e",
                lineHeight: 1.3
              },
              children: s.label
            })]
          }, s.label);
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "3rem 1.5rem",
        background: "#f0f4f8"
      },
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          width: "100%",
          maxWidth: "400px"
        },
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            marginBottom: "2.25rem"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            style: {
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: "2rem",
              fontWeight: 700,
              letterSpacing: "0.01em",
              color: "#1a2535",
              margin: "0 0 0.4rem"
            },
            children: "CONNEXION"
          }), /*#__PURE__*/_jsx("p", {
            style: {
              fontSize: "0.875rem",
              color: "#6b7f9e",
              margin: 0
            },
            children: "Acc\xE8s r\xE9serv\xE9 au personnel autoris\xE9."
          })]
        }), /*#__PURE__*/_jsx("div", {
          style: {
            padding: "18px",
            background: "#F1EADF",
            borderRadius: '9px',
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px"
          },
          children: /*#__PURE__*/_jsx(UserLogin, {})
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: "2.25rem",
            display: "flex",
            alignItems: "flex-start",
            gap: "0.75rem",
            padding: "0.75rem 1rem",
            borderRadius: "0.5rem",
            background: "rgba(37,99,235,0.04)",
            border: "1px solid rgba(37,99,235,0.12)"
          },
          children: [/*#__PURE__*/_jsx(ShieldCheck, {
            size: 14,
            style: {
              marginTop: "1px",
              flexShrink: 0,
              color: "#2563eb"
            }
          }), /*#__PURE__*/_jsx("p", {
            style: {
              fontSize: "0.72rem",
              lineHeight: 1.5,
              color: "#6b7f9e",
              margin: 0
            },
            children: "Cette session est s\xE9curis\xE9e et journalis\xE9e. Toute tentative d'acc\xE8s non autoris\xE9e est enregistr\xE9e."
          })]
        }), /*#__PURE__*/_jsx("p", {
          style: {
            marginTop: "2rem",
            textAlign: "center",
            fontFamily: "'DM Mono', monospace",
            fontSize: "0.68rem",
            color: "#b0bdcc"
          },
          children: "\xA9 2026 AloGaz \u2014 Tous droits r\xE9serv\xE9s"
        })]
      })
    }), /*#__PURE__*/_jsx("style", {
      children: "\n        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;600;700&family=Barlow:wght@400;500;600&family=DM+Mono:wght@400;500&display=swap');\n        @keyframes spin { to { transform: rotate(360deg); } }\n      "
    })]
  });
};
export default HomeContent;